import type { SofiaActionKind } from "../model/constants"
import type { SofiaProposedAction } from "../model/types"

const CREATION_RESOURCES: Partial<
  Record<SofiaActionKind, { label: string; plural: string }>
> = {
  create_metric: { label: "metric", plural: "metrics" },
  create_python_metric_draft: {
    label: "Python metric draft",
    plural: "Python metric drafts",
  },
  publish_python_metric: { label: "metric", plural: "metrics" },
  save_python_analysis_metric: { label: "metric", plural: "metrics" },
  create_persona: { label: "persona", plural: "personas" },
  create_agent: { label: "agent", plural: "agents" },
  create_test_set: { label: "test set", plural: "test sets" },
  create_dashboard: { label: "dashboard", plural: "dashboards" },
  build_dashboard: { label: "dashboard", plural: "dashboards" },
  create_report: { label: "report", plural: "reports" },
  create_widget: { label: "widget", plural: "widgets" },
  create_review_project: { label: "review project", plural: "review projects" },
  create_alert: { label: "alert", plural: "alerts" },
  create_monitor: { label: "alert", plural: "alerts" },
}

/** Existing-dashboard edits and editor-staged test cases keep their own controls. */
export function getCreationResource(proposal: SofiaProposedAction) {
  if (proposal.kind === "build_dashboard" && proposal.args.dashboard_id) {
    return undefined
  }
  return CREATION_RESOURCES[proposal.kind]
}
